import axios from 'axios';
import { getMockInitData } from '../utils/mockInitData';

// Используем относительный путь, так как фронтенд и бэкенд на одном сервере
const API_URL = '/api';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  // ============================================================
  //  1. Проверяем токен из localStorage (для веб-админки)
  // ============================================================
  const adminToken = localStorage.getItem('adminToken');
  if (adminToken) {
    config.headers['Authorization'] = `Bearer ${adminToken}`;
    console.log('🔑 Используем токен веб-админки из localStorage');
    return config;
  }

  // ============================================================
  //  2. Проверяем токен из URL (для быстрого доступа через ссылку)
  // ============================================================
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get('token');
  if (tokenFromUrl) {
    config.headers['Authorization'] = `Bearer ${tokenFromUrl}`;
    console.log('🔑 Используем Bearer-токен из URL');
    return config;
  }

  // ============================================================
  //  3. Стандартная авторизация через MAX (initData)
  // ============================================================
  let initData = (window as any).WebApp?.initData;
  let source = 'WebApp';
  
  // Если нет — пробуем из URL-фрагмента
  if (!initData) {
    const hash = window.location.hash;
    if (hash) {
      try {
        const params = new URLSearchParams(hash.substring(1));
        const webAppData = params.get('WebAppData') || 
                           params.get('initData') || 
                           params.get('tgWebAppData');
        
        // Если есть параметры, собираем их
        if (!webAppData && params.toString()) {
          // Игнорируем технические параметры
          const filteredParams: string[] = [];
          for (const [key, value] of params.entries()) {
            if (!['WebAppPlatform', 'WebAppVersion', 'WebAppDeviceName'].includes(key)) {
              filteredParams.push(`${key}=${value}`);
            }
          }
          if (filteredParams.length > 0) {
            initData = filteredParams.join('&');
            source = 'URL-fragment (собран)';
          }
        } else if (webAppData) {
          initData = webAppData;
          source = 'URL-fragment (WebAppData)';
        }
      } catch (error) {
        console.warn('⚠️ Ошибка парсинга URL-фрагмента:', error);
      }
    }
  }
  
  console.log(`🔑 initData из: ${source}`);
  console.log(`📝 Длина: ${initData?.length || 0}`);
  
  if (initData) {
    config.headers['X-Init-Data'] = initData;
  } else if (process.env.NODE_ENV === 'development') {
    const mockData = getMockInitData();
    console.log('🧪 Используем мок-данные для разработки');
    config.headers['X-Init-Data'] = mockData;
  }
  
  return config;
});

// ============================================================
//  🔄 ОБРАБОТКА ОШИБОК 401 (Unauthorized)
// ============================================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Если получили 401 и это не запрос к /login (чтобы не было цикла)
    if (error.response?.status === 401 && !error.config?.url?.includes('/login')) {
      console.error('❌ 401 Unauthorized — токен невалидный или истек');
      
      // Удаляем невалидный токен
      localStorage.removeItem('adminToken');
      
      // Если мы не на странице логина — перенаправляем туда
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    
    return Promise.reject(error);
  }
);